import { inject, Injectable } from '@angular/core';
import { UserUnifiedService } from '@thiememeulenhoff/ng-api-gateway';
import { UserData } from '@thiememeulenhoff/types';
import { tap } from 'rxjs';
import { UserRecentFacade } from '../user-recent/user-recent.facade';
import { PreferenceFacade } from '../preference/preference.facade';
import { UserSettingFacade } from '../user-setting/user-setting.facade';

@Injectable({
  providedIn: 'root',
})
export class UserUnifiedFacade {
  readonly #userUnifiedService = inject(UserUnifiedService);

  readonly #preferenceFacade = inject(PreferenceFacade);

  readonly #userSettingsFacade = inject(UserSettingFacade);

  readonly #userRecentFacade = inject(UserRecentFacade);

  initialize() {
    this.fetchUserData().subscribe();
  }

  fetchUserData() {
    return this.#userUnifiedService.fetchUserData().pipe(
      tap((userData: UserData) => {
        const preferences = userData.methodPreferences;
        this.#preferenceFacade.setMethodPreferences(preferences);

        const settings = userData.userSettings;
        this.#userSettingsFacade.setUserSettings(settings);

        this.#userRecentFacade.setRecents([
          ...(userData.recentMethods ?? []),
          ...(userData.recentArrangements ?? []),
          ...(userData.recentResources ?? []),
        ]);
      }),
    );
  }
}
